import React, { useState, useEffect,useContext } from "react";
import TextPargraph from "../../utils/TextParagraph";
import { BrowserView, MobileView,isMobile } from "react-device-detect";
import {useFetch} from "../../api/FetchApiData";
import './spinner.css';
import { MediaUrl } from "../../utils/media/Media";
import { useNavigate } from "react-router-dom";
import removeIcon from '../../icons/remove.webp';
import Select from "react-select";
import { Rating } from "react-simple-star-rating";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../AppContextProvider";

if (isMobile)
    import('./itempanier_mob.css').then(() => {});
else
    import('./itempanier.css').then(() => {});

export default function ItemInPanier({orArticlesRef,Item,setPanier})
{
    const [_Item,_setItem] = useState({...Item});
    const {t} = useTranslation();
    const [stockNotif,setStockNotif] = useState({color:'green',text:Item.stock + t('produit.stock-text')});
    const [Enabled,setEnabled] = useState({enabled:true, bg:'white',color:'black'});
    const [delivers,setDelivers] = useState([]);
    const [locationDates,setLocationDates] = useState([]);
    const fetchData = useFetch();
    const [AppState,setAppState] = useContext(AppContext);

    const navigator = useNavigate();

    const DeliverOption = (deliver)=>{
        let img_src = '/images/icons/delivry/delivry.webp';
        if(!!deliver.logo)
            img_src = MediaUrl(deliver.logo.image);
        //console.log(deliver);
        return(
        <div key={deliver.label} style={{display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',fontSize:'small',background:'transparent'}}>
            <div style={{display:'block',textAlign:'center',width:'25%',verticalAlign:'middle',margin:'0px',background:'transparent'}}>
                <img src={img_src} style={{width:'18px',borderRadius:'5px',margin:'auto'}} />
                {!!deliver.note && !deliver.is_dummy && <div style={{padding:'0px',marginTop:'-5px',textAlign:'center',fontSize:'xx-small'}}><span style={{color:'gray',fontSize:'7px',margin:'0px',padding:'0px'}}>{deliver.note} / 5</span></div>}
            </div>
            <div style={{maxWidth:'70%',margin:'0px auto 0px 7px',padding:'0px',verticalAlign:'middle'}}>
                <h5 style={{margin:'0px',marginBottom:isMobile?'0px':'0px',padding:'0px'}}><span style={{marginRight:'10px'}}>{deliver.title}</span></h5>
                {!!deliver.next_fret && <span style={{padding:'0px',color:'gray',fontSize:'xx-small',display:'block'}}> {deliver.next_fret.display_text} 
                    </span>}
            </div>
        </div>)
    }
    
    const [deliver,setDeliver] = useState({value:{id:9999,title:'Aucune livraison'},label:DeliverOption({title:'Aucune livraison'})});

    useEffect(()=>{
        let _delivers = [];
        Item.delivers.forEach(element => {
            _delivers.push({value:{id:element.id,title:element.title},label:DeliverOption(element)})
        });
        setDelivers([..._delivers]);
    },[Item.delivers])

    useEffect(()=>{
        if (Item.location_dates) 
        {
            const converted = Item.location_dates.map(d =>
            new DateObject({ date: d.date, format: "YYYY-MM-DD" }));
            setLocationDates(converted);
        }
    },[_Item.id,Item.location_dates])


    useEffect(()=>{
        if(_Item.article.stock<_Item.quantity)
        {setStockNotif({color:'orangered',text: ""+_Item.article.stock+" "+ t('produit.stock-text-out')+_Item.article.approvisionnement});}
        else
        {setStockNotif({color:'green',text:_Item.article.stock+" "+t("produit.stock-text")});}  
    },[_Item.quantity])

    useEffect(()=>{
        /*
        if(_Item.enabled)
        {
            setEnabled({enabled:true, bg:'white',color:'black'});
        }
        else
        {
            setEnabled({enabled:false, bg:'whitesmoke',color:'gray'});
        }
        */
    },[_Item.enabled])

    useEffect(()=>{
        fetchData.GetData(`panier/item/${_Item.id}/`).then((result)=>{
            if(result.result)
            {_setItem({...result.item});}
        });
    },[AppState.settings.devise,AppState.settings.lang])

    const remove=()=>
    {
        const _data = {id:_Item.id};
        fetchData.DeleteData(_data,'panier/item/').then((result)=>{
            if(result.result)
            {
                setPanier({...result.panier});
            }
        })
            
    }

    const onQuantityChange = (quantity)=>
    {
        if(quantity==='' || quantity===undefined || quantity===null)
            return;
        fetchData.PostData({id:_Item.id,quantity:quantity},'panier/item/').then((result)=>{
            if(result.result)
            {_setItem({...result.item});setPanier({...result.panier});}
        });
    }

    const onDeliverChange = (deliver)=>{
        fetchData.PostData({id:_Item.id,deliver_id:deliver},'panier/item/').then((result)=>{
            if(result.result)
            {_setItem({...result.item});setPanier({...result.panier});}
        });
        
    }

    const TranslateContry = (country)=>{
        if(country==='France')
            return t('produit.france');
        else if(country==='Turquie')
            return t('produit.turquie');
        else if(country==="Chine")
            return t('produit.chine');
        else if(country==='Comores')
            return t('produit.comores');
        else
            return ''
    }

    const onLocationDatesChange = (dates)=>{
        let _dates = dates.map(d=>new Date(d).toISOString());
        //console.log(_dates);
        fetchData.PostData({id:_Item.id,location_dates:_dates},'panier/item/').then((result)=>{
        if(result.result)
        {
            _setItem({...result.item});        
            setPanier({...result.panier});
    }});
        
    }

    const parse_date=(datestr)=>{
        return new Date(datestr);
    }

    const custom_style = {
    control: (base) => ({
      ...base,
      width:'100%'
    }),
    valueContainer: (base) => ({
      ...base,
      background: 'transparent', 
      padding: '0 8px',
    }),
    singleValue: (base) => ({
      ...base,
      background: 'transparent',
    }),
    placeholder: (base) => ({
      ...base,
      background: 'transparent',
    }),
    indicatorsContainer: (base) => ({ ...base, background: 'transparent' }),
    dropdownIndicator: (base) => ({ ...base, background: 'transparent' }),
    indicatorSeparator: (base) => ({ ...base, display: 'none' }),

}
    
    return(
            <fieldset className="Panier-Item" style={{backgroundColor:Enabled.bg,color:Enabled.color}}>
                    <img src={MediaUrl(_Item.article.image)} style={{verticalAlign:'middle',float:'inline-start',width:'20%'}} />
                    <h3 style={{textAlign:'left',fontSize:'normal'}} onClick={e=>{navigator(`/product/${_Item.article.id}`)}}>{_Item.article.title}</h3>
                    <h4 style={{fontSize:'small'}}> {t('produit.reference')} : {_Item.article.id} {(_Item.is_location) && <span style={{paddingLeft:'10px',color:'orangered'}}>Article en location</span>}</h4>
                    <TextPargraph style={{size:isMobile?'x-small':'small'}}  text={_Item.description} textminlength={100} /> 
                        <BrowserView style={{marginTop:'10px'}}>                     
                            <div className="livraison">
                                <div className="delivery-select" style={{width:'100%',textAlign:'center',margin:'10px auto 10px auto',display:'flex',flexDirection:'row'}}>
                                    <div style={{width:'60%'}}>
                                    <Select
                                        styles={custom_style}
                                        isClearable={false} 
                                        options={delivers}
                                        isSearchable = {false}
                                        value={!!_Item.deliver ? {value:{id:_Item.id,title:_Item.title},label:DeliverOption(_Item.deliver)} : null}
                                        placeholder={"Choississez votre livraison"}
                                        onChange={(value,action)=>{
                                            onDeliverChange(value.value.id);
                                        }}    
                                    />
                                    </div>
                                    <div style={{padding:'0px'}}>
                                        {!_Item.deliver && <span className="item-disabled" style={{color:'orange',padding:'0px',display:'block',fontSize:'x-small'}}>{t('panier.livreur.notif')}</span>}
                                        <span dir="rtl" style={{backgroundColor:Enabled.bg,color:Enabled.color,fontSize:'x-small',margin:'auto',paddingTop:'0px'}}>
                                            {t('panier.livraison-maison')} <span dir="ltr">{_Item.prices.delivery} {AppState.settings.devise==='euro'?'€':'KMF'}</span>
                                        </span>
                                    </div>
                                </div>
  
                            </div>
                        </BrowserView>
                        <MobileView>
                                <div dir={AppState.settings.lang==='ar'?"rtl":'ltr'} style={{display:'inline-block'}}>
                                    <label style={{marginRight:'10px'}}>{t('produit.quantite')} :</label>
                                    <input min={1} onChange={e=>{onQuantityChange(e.target.value);}} type="number" defaultValue={_Item.quantity} style={{width:'60px',marginLeft:'10px',marginRight:'10px'}}/>
                                    <span dir={AppState.settings.lang==='ar'?"rtl":'ltr'} style={{fontWeight:'bolder',marginLeft:'10px'}}>{_Item.prices.articles} {AppState.settings.devise==='euro'?'€':'KMF'}</span>
                                    <span style={{marginLeft:'10px',color:stockNotif.color}}>({stockNotif.text})</span>
                                </div>
                                <div>
                                    {_Item.is_location && (
                                    <div><label style={{marginRight:'10px'}}>{t('order.date')} :</label>
                                    <DatePicker multiple
                                        onChange={(dates)=>{onLocationDatesChange(dates);}}
                                        value={locationDates}
                                        minDate={new Date()}
                                        style={{width:"80%",marginTop:'8px',height:'22px',marginLeft:'5px',textAlign:'center'}}
                                        mapDays={({date})=>{
                                            const _dates = _Item.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                            const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                            return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                        format='DD/MM/YYYY' placeholder='Choisissez vos dates' />
                                    </div>)}
                                    </div>
                                    <div>
                                    <div className="delivery-select" style={{zIndex:99999,width:'100%',textAlign:'left',margin:'auto',marginTop:'5px',marginBottom:'10px',display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center'}}>
                                        <div style={{width:'50%',verticalAlign:'middle',marginRight:'5px'}}>
                                            <label style={{marginRight:'0px'}}>{!_Item.deliver && <span className="item-disabled" style={{color:'orange',padding:'0px',fontSize:'x-small'}}>{t('panier.livreur-notif')}</span>}</label>
                                            <Select 
                                                isClearable={false} 
                                                options={delivers}
                                                isSearchable = {false}
                                                value={!!_Item.deliver ? {value:{id:_Item.id,title:_Item.title},label:DeliverOption(_Item.deliver)} : null}
                                                placeholder={"Livreur"}
                                                styles={{menuPortal:(base)=>({...base, zIndex:99999})}} 
                                                onChange={(value,action)=>{
                                                    onDeliverChange(value.value.id); 
                                                }}    
                                            />
                                        </div>
                                        <div dir={AppState.settings.lang==='ar'?'rtl':'ltr'} className="livraison" style={{width:'45%',verticalAlign:'middle'}}>
                                            <span style={{backgroundColor:Enabled.bg,color:Enabled.color}}>
                                                {t('panier.livraison')+'  '} {TranslateContry(_Item.article.delivery_from)} - {t('produit.comores')} {_Item.prices.delivery} {AppState.settings.devise==='euro'?'€':'KMF'}
                                            </span>
                                        </div>
                                </div>
                                </div>
                                <img src={removeIcon} onClick={e=>{remove();}} style={{float:'right',borderStyle:'none',borderRadius:'5px',width:'20px'}} />
                        </MobileView>
                    
                <BrowserView>
                    <div className="PanierItemControls">
                            <div style={{display:'inline-flex'}}>
                                <label style={{marginRight:'10px'}}>{t('produit.quantite')} :</label>
                                <input min={1} onChange={e=>{onQuantityChange(e.target.value);}} type="number" defaultValue={_Item.quantity} style={{width:'60px'}}/>
                            </div>
                            <span style={{fontWeight:'bolder',marginLeft:'10px'}}>{_Item.prices.articles} {AppState.settings.devise==='euro'?'€':'KMF'}</span>
                            <span style={{marginLeft:'10px',color:stockNotif.color,marginRight:'20px',fontSize:'small'}}>({stockNotif.text})</span>
                            <div style={{marginTop:'10px'}}>
                                {_Item.is_location && (
                                <>
                                <label style={{marginRight:'10px'}}>{t('produit.dates')} :</label>
                                <DatePicker multiple
                                    onChange={onLocationDatesChange}
                                    minDate={new Date()}
                                    style={{width:"70%",height:'25px',marginLeft:'5px',textAlign:'center'}}
                                    value={locationDates}
                                    mapDays={({date})=>{
                                        let _dates = _Item.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                        const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                        return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                    format='DD/MM/YYYY' placeholder='Choisissez vos dates' />
                                    </>)}
                                <input onClick={e=>{remove();}} style={{float:'right',marginTop:'5px',backgroundColor:'#FFCCCB',borderStyle:'none',borderRadius:'5px',padding:'5px 10px',margin:'0px 10px 10px 0px'}} type="button" value={t('panier.supprimer')} />
                            </div>
                    </div>
                </BrowserView>
            </fieldset>
    );
}